/* eslint-disable max-len */
/* eslint-disable no-undef */
import React from "react";
import { Link } from "react-router-dom";
import CreateAdminMissionAyushChairUser from './AdminMissionAyushChair/CreateUser.js';
import CreateAssociationPractitionerUser from './AssociationPractitioner/CreateUser.js';
import vieweyeicoSvg from '../../../../public/vieweyeico.svg';
import filtericoSvg from '../../../../public/fltricon.svg';
import Modal from 'react-modal';
import UserService from '../../../../services/UserService';
import { Chart } from "react-google-charts";
import { showLoading } from 'react-global-loading';
// import { userData } from "../../../../services/index.js";

class AllUsers extends React.Component {
  constructor(props) {
    super(props);
    const url = new URL(window.location);
    this.state = {
      selectedUser: 0,
      usersList: [],
      showUserCreateModal: false,
      type: '',
      userData: [],
      showUserViewModal: false, selectedSort: '',
      searchedUser: [], uname: url.searchParams.get('uname') || '', location: url.searchParams.get('location'),
      users: [
        { name: "Mission Users", id: 2 },
        { name: "Association Users", id: 3 },
        { name: "Practitioners", id: 4 }
      ],
      data: [
        ["months", "Approved", "Disapproved"],
        ["Jan", 400, 400],
        ["Feb", 700, 460],
        ["Mar", 660, 300],
        ["Apr", 870, 540],
        ["May", 400, 400],
        ["Jun", 700, 460],
        ["Jul", 660, 300],
        ["Aug", 870, 540],
        ["Sept", 400, 400],
        ["Oct", 700, 460],
        ["Nov", 660, 300],
        ["Dec", 870, 540],
      ],
    };
  }

  componentDidMount = () => {
    this.filterUser();
  };

  getUsersList = (query) => {
    showLoading(true);
    UserService.getUsersList(query)
      .then((result) => {
        if (!result) {
          return;
        }
        this.setState({ usersList: result });

        showLoading(false);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  onSelectedUser = (index) => {
    const query = {}; const url = new URL(window.location);
    index ? query.role = this.state.users[index].name : '';
    this.getUsersList(query);
    this.setState({ selectedUser: index });
    this.setState({ uname: '', location: '' });
    url.searchParams.delete('uname');
    url.searchParams.delete('location');
    window.history.pushState(null, '', url.toString());
  };

  filterUser = () => {

    const url = new URL(window.location);
    { this.state.uname ? url.searchParams.set('uname', this.state.uname) : url.searchParams.delete('uname') }
    { this.state.location ? url.searchParams.set('location', this.state.location) : url.searchParams.delete('location') }
    { this.state.selectedSort ? url.searchParams.set('sortBy', this.state.selectedSort) : url.searchParams.delete('sortBy') }

    let query = {};
    this.state.uname && (query.uname = this.state.uname);
    this.state.location && (query.by = this.state.location);
    this.state.selectedSort && (query.sortBy = this.state.selectedSort);
    query.role = this.state.users[this.state.selectedUser].name;
    this.getUsersList(query);
    window.history.pushState(null, '', url.toString());

  };

  onSortSelected = (e) => {
    this.setState({ selectedSort: e.target.value }, function () {
      this.filterUser();
    });

  };

  render() {

    const { users, searchedUser, selectedUser, showUserCreateModal, usersList, showUserViewModal, type, uname, location, selectedSort } = this.state;
    return (
      <>
        <div className="container-fluid" id="main">
          <Modal
            isOpen={showUserCreateModal || showUserViewModal}
            shouldCloseOnOverlayClick={true}
            ariaHideApp={false}
          >
            {[1, 2, 5].includes(users[selectedUser]?.id) ?
              <CreateAdminMissionAyushChairUser dismissModal={(e) => (this.setState(
                type === 'view' ? { showUserViewModal: !this.state.showUserViewModal } : { showUserCreateModal: !this.state.showUserCreateModal }
              ), this.getUsersList())} {...this.state} /> : <CreateAssociationPractitionerUser dismissModal={(e) => (this.setState(type === 'view' ? { showUserViewModal: !this.state.showUserViewModal } : { showUserCreateModal: !this.state.showUserCreateModal }), this.getUsersList())} {...this.state} />}

          </Modal>

          <nav aria-label="breadcrumb">
          </nav>
          <hr></hr>
          <div className="row">
            <div className="col-12">
              <h3><b>Users</b></h3>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-12">
              <ul className="nav nav-tabs admintabs" >
                {users?.map((item, index) =>
                  <li className="nav-item" key={index} role="presentation">
                    <button className={`nav-link + ${selectedUser === index ? 'active' : ``}`} data-bs-toggle="tab" onClick={() => this.onSelectedUser(index)} data-bs-target={'#' + item.name} type="button" role="tab" aria-controls={item.name} aria-selected="true">
                      {item.name}
                    </button>
                  </li>)}
              </ul>
              {users[selectedUser] && <div className="tab-content bg-white pt-4 px-4 mt-4" >
                <div className="tab-pane fade show active allcountries-tabs" aria-labelledby="#all-countries">
                  <div className="row" id="#all-countries">
                    <div className="col-md-9">
                      <h4 className="fs-3"><b>{users[selectedUser].name} </b></h4>
                      <p>{users[selectedUser].name} have super admin rights over the AGP portal</p>
                    </div>
                    <div className="col-md-3 text-end">
                      <button type="button" className="btn theme-btn-fill btndbg" onClick={(e) => this.setState({ type: 'create', showUserCreateModal: !this.state.showUserCreateModal })}>Create {users[selectedUser].name}</button>
                    </div>
                  </div>
                  {/* {upcoming */}
                  <div className="row mt-3">
                    <div className="col-md-4">
                      <div className="form-group position-relative sortlist">
                        <select className="form-select" id="SortingList" aria-labelledby="SortingList" value={selectedSort} onChange={(e) => this.onSortSelected(e)}>
                          <option defaultValue value=''>Sort by</option>
                          <option value="nToO">New to Old</option>
                          <option value="oToN">Old to New</option>
                          <option value="AToz">A to Z</option>
                          <option value="zToA">Z to A</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-7 hdblk sl-block">
                      <div className="form-group has-search user-search-location-block">
                        <span className="fa fa-search form-control-feedback"></span>
                        <label htmlFor="productname" id="username" className="bldlbl hdlb">Search by user name</label>
                        <input type="text" className="form-control adminsearchbox" aria-labelledby="username" onChange={(e) => this.setState({ uname: e.target.value })} onKeyDown={e =>
                          e.key === "Enter" && this.filterdata()} value={uname} placeholder="Search by user name" />
                      </div>
                      <span className="divide"></span>
                      <div className="form-group has-search user-search-location-block">
                        <span className="fa fa-map-marker form-control-feedback"></span>
                        <label htmlFor="productname" id="location" className="bldlbl hdlb">enter location or pin code</label>
                        <input type="text" className="form-control adminlocationbox" aria-labelledby="location" placeholder="Enter location or Pin/ZIP code" onChange={(e) => this.setState({ location: e.target.value })} value={location} onKeyDown={e =>
                          e.key === "Enter" && this.filterdata()} />
                      </div>
                      <span className="divide"></span>
                      {/* <div className="form-group position-relative user-search-location-block">
                        <div className="searchbtn"> <button type="button" className="btn btndbg border-0 rounded-0 p-2" onClick={() => this.filterUser()}>Search</button></div>
                      </div> */}

                    </div>
                  </div>
                  <div className="row mt-4">
                    {usersList.length > 0 ? <div className="col-12">
                      <h5 className="card-title fs-5 fw-normal text-dark">List of {users[selectedUser].name}  </h5>
                      <hr></hr>
                      <div className="table-responsive">
                        <table className="table all-users-admin w-100 m-allusers">
                          <thead>
                            <tr className="details-group mt-4">
                              <td className="thead">User</td>
                              <td className="thead">Country</td>
                              <td className="thead">Status</td>
                              <td className="thead">View</td>
                              <td className="thead">Delete</td>
                            </tr>
                          </thead>
                          <tbody>
                            {usersList.map((item, index) => <tr key={index} className="details-group">
                              <td className="d-flex align-items-center">
                                <img src={item.data?.user_image?.length > 0 ? item.data?.user_image[0] : item?.user_image} className="img-fluid avatarimg" alt="Avatar" />
                                <div className="d-flex name-id ms-2">
                                  <span>{item.data?.display_name}</span>
                                  <small>{item.data?.user_email}</small>
                                </div>
                              </td>
                              <td>
                                <span>{item?.data.user_country[0]?.blogname || ''}</span>
                              </td>
                              <td>
                                <span>{item.status === 'pending' ? "Pending" : "Approved"}</span>
                              </td>
                              <td onClick={() => this.setState({ type: 'view', userData: item, showUserViewModal: !this.state.showUserViewModal })}>
                                <img src={vieweyeicoSvg} className="img-fluid" alt="view details" />
                              </td>
                              <td><i className="fa fa-trash fa-2x" aria-hidden="true"></i></td>
                            </tr>)}
                          </tbody>
                        </table>
                      </div>
                    </div> : <h3>No users Found</h3>}
                    {/* <div className="col-12 d-flex justify-content-center mt-4 mb-4">
                      <nav aria-label="Page navigation">
                        <ul className="pagination eve-pagination">
                          <li>
                            <Link to='/' aria-label="Previous">
                              <span aria-hidden="true"><i className="fa fa-chevron-left" aria-hidden="true"></i></span>
                            </Link>
                          </li>
                          <li className="active "><Link to="/" className="btndbg">01</Link></li>
                          <li><Link to="/">02</Link></li>
                          <li><Link to="/">03</Link></li>
                          <li><Link to="/">04</Link></li>
                          <li><Link to="/">05</Link></li>
                          <li>
                            <Link to='/' aria-label="Next">
                              <span aria-hidden="true"><i className="fa fa-chevron-right" aria-hidden="true"></i></span>
                            </Link>
                          </li>
                        </ul>
                      </nav>
                    </div> */}
                  </div>
                </div>
              </div>}

            </div>
          </div>
        </div >
      </>
    );
  }
}
export default AllUsers;